(() => {
  window.global.registeredAlpineComponents = {};

  invokersPolyfill();
  dialogToggleEventsPolyfill();
  dialogClickOutside();

  function invokersPolyfill() {
    var isSupported = isSupportedFn();

    if (!isSupported) {
      var scriptEl = document.createElement('script');

      scriptEl.src = window.global.asset_url['js-vendor-invokers-polyfill@0.6.1.js'];
      scriptEl.async = true;

      document.head.appendChild(scriptEl);
    }

    function isSupportedFn() {
      return (
        typeof HTMLButtonElement !== 'undefined' &&
        'command' in HTMLButtonElement.prototype &&
        'source' in ((globalThis.CommandEvent || {}).prototype || {})
      );
    }
  };

  function dialogToggleEventsPolyfill() {
    var isSupported = isSupportedFn();

    if (!isSupported) {
      var scriptEl = document.createElement('script');

      scriptEl.src = window.global.asset_url['js-vendor-dialog-toggle-events-polyfill@1.1.4.js'];
      scriptEl.async = true;

      document.head.appendChild(scriptEl);
    }

    function isSupportedFn() {
      if (typeof HTMLDialogElement !== 'function') {
        return false;
      }

      var supported = false;

      var dialog = document.createElement('dialog');

      dialog.addEventListener('beforetoggle', (e) => {
        supported = true;
        e.preventDefault();
      });

      dialog.show();

      return supported;
    };
  };

  function dialogClickOutside() {
    document.addEventListener('click', (event) => {
      if (event.target.tagName == 'DIALOG') {
        event.target.close();
      }
    });
  };
})();
